const YES = [
  'Quieres libertad financiera y no depender de un jefe para pagar tus facturas',
  'Quieres montar tu propio negocio online o potenciar el que ya tienes',
  'Estás harto de la teoría y quieres aprendizaje práctico que se pueda aplicar hoy',
  'Valoras rodearte de personas con mentalidad emprendedora que te empujan hacia arriba',
  'Estás dispuesto a invertir tiempo y energía real en construir algo tuyo',
];

const NO = [
  'Buscas un título oficial que enmarcar y colgar en la pared de tu oficina',
  'Esperas resultados sin esfuerzo ni compromiso por tu parte',
  'Prefieres teoría académica sobre casos prácticos reales y aplicables',
  'No tienes ningún interés en participar ni interactuar con la comunidad',
  'Crees que el aprendizaje real se mide en horas de clase y no en resultados',
];

const CheckIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const CrossIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export default function ParaQuien() {
  return (
    <div className="section" id="paraquien">
      <div style={{ marginBottom: 52 }} data-stagger="80">
        <div className="section-label r">¿Para quién es?</div>
        <h2 className="section-title r">Sé honesto contigo mismo</h2>
        <p className="section-sub r">
          Random College no es para todo el mundo. Y eso es exactamente lo que lo hace diferente.
        </p>
      </div>
      <div className="audience-grid" data-stagger="120">
        <div className="audience-card yes r r-left">
          <div className="audience-card-header">
            <div className="audience-badge">✓</div>
            <h3>Es para ti si...</h3>
          </div>
          {YES.map((text) => (
            <div className="audience-item" key={text}>
              <div className="audience-check">
                <CheckIcon />
              </div>
              <p>{text}</p>
            </div>
          ))}
        </div>

        <div className="audience-card no r r-right">
          <div className="audience-card-header">
            <div className="audience-badge">✕</div>
            <h3>NO es para ti si...</h3>
          </div>
          {NO.map((text) => (
            <div className="audience-item" key={text}>
              <div className="audience-check">
                <CrossIcon />
              </div>
              <p>{text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
